module.exports = __webpack_public_path__ + "static/media/config.162a33df.svg";